import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('deptMngStore', Object.keys(getters)),
	...mapState('deptMngStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('deptMngStore', Object.keys(actions)),
	...mapMutations('deptMngStore', Object.keys(mutations))
};
